
import React, { useState } from 'react'
import moment from 'moment'
import { momentCalendarConfig } from '../../../utils/baseStringUtils'
import EmptyCell from './EmptyCell'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'

export default function HeartRateCell (props) {
  const [memberObj] = useState(props.memberObj)

  if (!memberObj.user.has_heart_rate || !memberObj.heart_rate) {
    return <EmptyCell message='No heart rate data' />
  }

  const lastMeasurement = moment(memberObj.heart_rate.latest_measurement.timestamp)
  const latestCol = (
    <Box>
      <div className='member-row__latest'> {`${Math.round(memberObj.heart_rate.latest_measurement.heart_rate * 10) / 10} ${memberObj.heart_rate.information.units.heart_rate}`} </div>
      <div className='member-row__latest-timestamp'> {lastMeasurement.calendar(null, momentCalendarConfig)} </div>
    </Box>
  )

  return (
    <Grid container>
      <Grid item xs={12}> {latestCol} </Grid>
    </Grid>
  )
}
